module.exports = __webpack_public_path__ + "img/rs_whiteblackT-logo.51e0767.png";